/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_AreaInputs */

const en_admin_area = /** @type {(inputs: Admin_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Area`)
};

const de_admin_area = /** @type {(inputs: Admin_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrationsbereich`)
};

/**
* | output |
* | --- |
* | "Admin Area" |
*
* @param {Admin_AreaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_area = /** @type {((inputs?: Admin_AreaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_AreaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_area(inputs)
	return en_admin_area(inputs)
});